import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Footer from "./components/Footer";

import AboutPage from "./pages/AboutPage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import PlanningPage from "./pages/PlanningPage";
import InteriorPage from "./pages/InteriorPage";
import ExteriorPage from "./pages/ExteriorPage";
import ProjectDetail from "./pages/ProjectDetail";
import ScrollToTop from "./components/ScrollToTop";
import { WhatsAppButton } from "./components/WhatsappButton";
import AIAssistantButton from "./components/AiAssistantButton";
import AssistantPage from "./pages/Assistant";




const App: React.FC = () => {
  const location = useLocation();
  const isAssistant = location.pathname.startsWith("/assistant");

  return (
    <div style={{ overflowX: "hidden", margin: 0, padding: 0 }}>
      <Header />
      <ScrollToTop />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <About />
              <Projects />
              <Footer />
            </>
          }
        />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/planning" element={<PlanningPage />} />
        <Route path="/interior" element={<InteriorPage />} />
        <Route path="/exterior" element={<ExteriorPage />} />
        <Route path="/projects/:slug" element={<ProjectDetail />} />
        <Route path="/assistant" element={<AssistantPage />} />
      </Routes>

      {/* Hide floaters on the Assistant page only */}
      {!isAssistant && <AIAssistantButton />}
      {!isAssistant && <WhatsAppButton />}
    </div>
  );
};

export default App;
